import { Link } from "react-router-dom";

/**
 * Services section - matches design-4 dark section
 * Dark olive background with service cards
 */
export function ServicesSection() {
  const services = [
    {
      title: "Home Loans",
      description: "Grants, schemes & expert guidance",
      image: "/content/home-loan-small.jpeg",
      href: "/home-loans",
    },
    {
      title: "Refinancing",
      description: "Better rates & access equity",
      image: "/content/refinancing-small.jpeg",
      href: "/home-loans/refinancing",
    },
    {
      title: "Investment",
      description: "Build your property portfolio",
      image: "/content/investment-small.jpeg",
      href: "/home-loans/investment",
    },
    {
      title: "Business Loan",
      description: "Flexible funding for business growth",
      image: "/content/bussiness-loan.jpeg",
      href: "/business-loans/term-loans",
    },
    {
      title: "Asset Finance",
      description: "Finance vehicles & equipment",
      image: "/content/asset-finance.jpeg",
      href: "/business-loans/asset-finance",
    },
  ];

  return (
    <section className="px-4 py-4">
      <div className="bg-primary rounded-[2.5rem] py-16 md:py-24 px-6 md:px-12">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <p className="section-label mb-4">Our Services</p>
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-primary-foreground max-w-2xl mx-auto leading-tight">
              Our tailored solutions for every situation
            </h2>
            <p className="mt-4 text-primary-foreground/90 max-w-xl mx-auto">
              Whether you're buying your first home or expanding your investment portfolio,
              we have the expertise to help.
            </p>
          </div>

          {/* Service Cards */}
          <div className="grid md:grid-cols-3 gap-4">
            {services.map((service) => (
              <Link
                key={service.href}
                to={service.href}
                className="group relative aspect-[4/3] rounded-2xl overflow-hidden bg-white/5"
              >
                {/* Background Image */}
                <div
                  className="absolute inset-0"
                  style={{
                    backgroundImage: `url('${service.image}')`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }}
                />

                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />

                {/* Content */}
                <div className="absolute inset-0 p-6 flex flex-col justify-end">
                  <h3 className="font-semibold text-xl text-white mb-1">
                    {service.title}
                  </h3>
                  <p className="text-white/70 text-sm">
                    {service.description}
                  </p>
                </div>

                {/* Hover */}
                <div className="absolute inset-0 bg-accent/0 group-hover:bg-accent/20 transition-colors duration-300" />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
